import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { WEBSITE_API } from '../api/website-api';
import { WebsiteId } from '../types/website-interface';
import { LocaleEnum } from '@systemeio/ui';
interface WebsitePAgeListItemInterface {
  pageContentId: number;
  name: string;
  locale: LocaleEnum;
}
export function useWebsitePageListAll(websiteId, t0) {
  const $ = _c(6);
  const shouldFetch = t0 === undefined ? true : t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const t2 = `${WEBSITE_API}/websites/${websiteId}/list-all-pages`;
  let t3;
  if ($[1] !== t2) {
    t3 = [t2, RequestModuleEnum.Websites];
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: websitePageListAll,
    mutate
  } = useControlledSwr(t3, fetcher, undefined, shouldFetch && !!user && !!websiteId);
  let t4;
  if ($[3] !== mutate || $[4] !== websitePageListAll) {
    t4 = {
      websitePageListAll,
      mutate
    };
    $[3] = mutate;
    $[4] = websitePageListAll;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}